import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@auth';
import { routes } from '@/shared/routes';
import AuthPage, { AuthMode } from '@/app/pages/AuthPage';
import AuthLayout from '@/app/layouts/AuthLayout';
import ProtectedRoute from '@/app/components/ProtectedRoute';
import GuestRoute from '@/app/components/GuestRoute';
import DashboardPage from '@/app/pages/DashboardPage';
import SettingsPage from '@/app/pages/settings/SettingsPage';
import NotFoundPage from '@/app/pages/NotFoundPage';
import PasswordResetRequestPage from '@/app/pages/auth/PasswordResetRequestPage';
import PasswordResetPage from '@/app/pages/auth/PasswordResetPage';
import EmailVerificationConfirmPage from '@/app/pages/auth/EmailVerificationConfirmPage';
import TermsPage from '@/app/pages/legal/TermsPage';
import PrivacyPage from '@/app/pages/legal/PrivacyPage';

export default function App() {
  const { isLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const authQueryMode = new URLSearchParams(location.search).get('auth') === 'signup' ? 'signup' : null;

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  const handleSwitchMode = (mode: AuthMode) => {
    navigate(mode === 'signup' ? routes.app.signup : routes.app.signin);
  };

  return (
    <Routes>
      <Route
        path={routes.app.signin}
        element={
          <GuestRoute>
            <AuthPage mode="signin" onSwitchMode={handleSwitchMode} />
          </GuestRoute>
        }
      />
      <Route
        path={routes.app.signup}
        element={
          <GuestRoute>
            <AuthPage mode="signup" onSwitchMode={handleSwitchMode} />
          </GuestRoute>
        }
      />
      <Route path={routes.terms} element={<TermsPage />} />
      <Route path={routes.privacy} element={<PrivacyPage />} />
      <Route
        path={routes.app.passwordReset}
        element={
          <GuestRoute>
            <AuthLayout>
              <PasswordResetRequestPage onBackToSignIn={() => navigate(routes.app.signin)} />
            </AuthLayout>
          </GuestRoute>
        }
      />
      <Route
        path="/app/user/password-reset/:token"
        element={
          <GuestRoute>
            <AuthLayout>
              <PasswordResetPage />
            </AuthLayout>
          </GuestRoute>
        }
      />
      <Route
        path="/app/user/verify-email/:token"
        element={
          <AuthLayout>
            <EmailVerificationConfirmPage />
          </AuthLayout>
        }
      />
      <Route
        path={routes.app.root}
        element={
          <ProtectedRoute fallback={authQueryMode === 'signup' ? routes.app.signup : routes.app.signin}>
            <DashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={routes.app.settings}
        element={
          <ProtectedRoute>
            <SettingsPage />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

